import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.ConversationOrderSummary'

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Requesting {count, plural, one {# item} other {# items}}',
  },
  estimatedTotal: {
    id: `${scope}.estimatedTotal`,
    defaultMessage: 'Estimated total',
  },
  continueButton: {
    id: `${scope}.continueButton`,
    defaultMessage: 'Continue to order request form',
  },
  disclaimer: {
    id: `${scope}.disclaimer`,
    defaultMessage:
      'These details will pre-fill the order request form, ready for you to review and submit.',
  },
  increaseQuantityAriaLabel: {
    id: `${scope}.increaseQuantityAriaLabel`,
    defaultMessage: 'Increase quantity of {name}',
  },
  decreaseQuantityAriaLabel: {
    id: `${scope}.decreaseQuantityAriaLabel`,
    defaultMessage: 'Decrease quantity of {name}',
  },
  removeItemAriaLabel: {
    id: `${scope}.removeItemAriaLabel`,
    defaultMessage: 'Remove {name}',
  },
})
